"use strict";

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactBootstrapTable2Toolkit = t(require("react")) : e.ReactBootstrapTable2Toolkit = t(e.React);
}(void 0, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 3);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(6)();
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      s = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      c = r(0),
      f = n(c),
      p = r(1),
      d = n(p),
      h = r(15),
      b = n(h),
      y = r(21),
      v = n(y),
      m = f.default.createContext(),
      g = function (e) {
        function t(e) {
          o(this, t);
          var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
            n = {};
          return r._ = null, r.onClear = r.onClear.bind(r), r.onSearch = r.onSearch.bind(r), r.onColumnToggle = r.onColumnToggle.bind(r), r.setDependencyModules = r.setDependencyModules.bind(r), e.columnToggle && (n.columnToggle = e.columns.reduce(function (e, t) {
            return e[t.dataField] = !t.hidden, e;
          }, {})), n.searchText = "object" === i(e.search) ? e.search.defaultSearch || "" : "", r.state = n, r;
        }
        return u(t, e), s(t, [{
          key: "UNSAFE_componentWillReceiveProps",
          value: function (e) {
            var t = this.state.columnToggle;
            t = e.columnToggle ? e.columns.reduce(function (e, t) {
              return e[t.dataField] = !t.hidden, e;
            }, {}) : null, this.setState(l({}, this.state, {
              columnToggle: t
            }));
          }
        }, {
          key: "onSearch",
          value: function (e) {
            e !== this.state.searchText && this.setState({
              searchText: e
            });
          }
        }, {
          key: "onClear",
          value: function () {
            this.setState({
              searchText: ""
            });
          }
        }, {
          key: "onColumnToggle",
          value: function (e) {
            var t = this.state.columnToggle;
            t[e] = !t[e], this.setState(l({}, this.state, {
              columnToggle: t
            }));
          }
        }, {
          key: "setDependencyModules",
          value: function (e) {
            this._ = e;
          }
        }, {
          key: "render",
          value: function () {
            var e = {
              keyField: this.props.keyField,
              columns: this.props.columns,
              data: this.props.data,
              bootstrap4: this.props.bootstrap4,
              setDependencyModules: this.setDependencyModules,
              registerExposedAPI: this.registerExposedAPI
            };
            return this.props.search && (e.search = {
              searchContext: (0, v.default)(this.props.search),
              searchText: this.state.searchText
            }), this.props.columnToggle && (e.columnToggle = {
              toggles: this.state.columnToggle
            }), f.default.createElement(m.Provider, {
              value: {
                searchProps: {
                  searchText: this.state.searchText,
                  onSearch: this.onSearch,
                  onClear: this.onClear
                },
                csvProps: {
                  onExport: this.handleExportCSV
                },
                columnToggleProps: {
                  columns: this.props.columns,
                  toggles: this.state.columnToggle,
                  onColumnToggle: this.onColumnToggle
                },
                baseProps: e
              }
            }, this.props.children);
          }
        }]), t;
      }((0, b.default)(f.default.Component));
    g.propTypes = {
      keyField: d.default.string.isRequired,
      data: d.default.array.isRequired,
      columns: d.default.array.isRequired,
      children: d.default.node.isRequired,
      bootstrap4: d.default.bool,
      search: d.default.oneOfType([d.default.bool, d.default.shape({
        defaultSearch: d.default.string,
        searchFormatted: d.default.bool
      })]),
      exportCSV: d.default.oneOfType([d.default.bool, d.default.shape({
        fileName: d.default.string,
        separator: d.default.string,
        ignoreHeader: d.default.bool,
        ignoreFooter: d.default.bool,
        noAutoBOM: d.default.bool,
        blobType: d.default.string,
        exportAll: d.default.bool,
        onlyExportFiltered: d.default.bool,
        onlyExportSelection: d.default.bool
      })])
    }, g.defaultProps = {
      search: !1,
      exportCSV: !1,
      bootstrap4: !1
    }, t.default = {
      Provider: g,
      Consumer: m.Consumer
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ColumnToggle = t.CSVExport = t.Search = t.ToolkitContext = void 0;
    var o = r(4);
    Object.defineProperty(t, "Search", {
      enumerable: !0,
      get: function () {
        return n(o).default;
      }
    });
    var a = r(11);
    Object.defineProperty(t, "CSVExport", {
      enumerable: !0,
      get: function () {
        return n(a).default;
      }
    });
    var u = r(13);
    Object.defineProperty(t, "ColumnToggle", {
      enumerable: !0,
      get: function () {
        return n(u).default;
      }
    });
    var l = r(2),
      i = n(l),
      s = r(22),
      c = n(s);
    t.default = c.default;
    t.ToolkitContext = i.default;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(5),
      a = n(o),
      u = r(10),
      l = n(u);
    t.default = {
      SearchBar: a.default,
      ClearSearchButton: l.default
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      i = arguments,
      s = r(0),
      c = n(s),
      f = r(1),
      p = n(f),
      d = function (e, t, r) {
        var n = void 0;
        return function () {
          var o = function () {
              n = null, r || e.apply(void 0, i);
            },
            a = r && !n;
          clearTimeout(n), n = setTimeout(o, t || 0), a && e.appy(void 0, i);
        };
      },
      h = function (e) {
        function t(e) {
          o(this, t);
          var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return r.onChangeValue = function (e) {
            r.setState({
              value: e.target.value
            });
          }, r.onKeyup = function () {
            var e = r.props,
              t = e.delay,
              n = e.onSearch;
            d(function () {
              n(r.input.value);
            }, t)();
          }, r.state = {
            value: e.searchText
          }, r;
        }
        return u(t, e), l(t, [{
          key: "UNSAFE_componentWillReceiveProps",
          value: function (e) {
            this.setState({
              value: e.searchText
            });
          }
        }, {
          key: "render",
          value: function () {
            var e = this,
              r = this.props,
              n = r.className,
              o = r.style,
              a = r.placeholder,
              u = r.tableId,
              l = r.srText;
            return c.default.createElement("label", {
              htmlFor: "search-bar-" + u,
              className: "search-label"
            }, c.default.createElement("span", {
              id: "search-bar-" + u + "-label",
              className: "sr-only"
            }, l), c.default.createElement("input", {
              ref: function (t) {
                return e.input = t;
              },
              id: "search-bar-" + u,
              type: "text",
              style: o,
              "aria-labelledby": "search-bar-" + u + "-label",
              onKeyUp: function () {
                return e.onKeyup();
              },
              onChange: this.onChangeValue,
              className: "form-control " + n,
              value: this.state.value,
              placeholder: a || t.defaultProps.placeholder
            }));
          }
        }]), t;
      }(c.default.Component);
    h.propTypes = {
      onSearch: p.default.func.isRequired,
      className: p.default.string,
      placeholder: p.default.string,
      style: p.default.object,
      delay: p.default.number,
      searchText: p.default.string,
      tableId: p.default.string,
      srText: p.default.string
    }, h.defaultProps = {
      className: "",
      style: {},
      placeholder: "Search",
      delay: 250,
      searchText: "",
      tableId: "0",
      srText: "Search this table"
    }, t.default = h;
  }, function (e, t, r) {
    "use strict";

    var n = r(7),
      o = r(8),
      a = r(9);
    e.exports = function () {
      function e(e, t, r, n, u, l) {
        l !== a && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t
      };
      return r.checkPropTypes = n, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return function () {
        return e;
      };
    }
    var o = function () {};
    o.thatReturns = n, o.thatReturnsFalse = n(!1), o.thatReturnsTrue = n(!0), o.thatReturnsNull = n(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r, n, a, u, l, i) {
      if (o(t), !e) {
        var s;
        if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [r, n, a, u, l, i],
            f = 0;
          s = new Error(t.replace(/%s/g, function () {
            return c[f++];
          })), s.name = "Invariant Violation";
        }
        throw s.framesToPop = 1, s;
      }
    }
    var o = function (e) {};
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(0),
      a = n(o),
      u = r(1),
      l = n(u),
      i = function (e) {
        var t = e.onClear,
          r = e.text,
          n = e.className;
        return a.default.createElement("button", {
          className: "btn btn-default " + n,
          onClick: t
        }, r);
      };
    i.propTypes = {
      onClear: l.default.func.isRequired,
      className: l.default.string,
      text: l.default.string
    }, i.defaultProps = {
      text: "Clear",
      className: ""
    }, t.default = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(12),
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = {
      ExportCSVButton: o.default
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      var r = {};
      for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
      return r;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      u = r(0),
      l = n(u),
      i = r(1),
      s = n(i),
      c = function (e) {
        var t = e.onExport,
          r = e.children,
          n = e.className,
          u = o(e, ["onExport", "children", "className"]);
        return l.default.createElement("button", a({
          type: "button",
          className: "react-bs-table-csv-btn btn btn-default " + n,
          onClick: function () {
            return t();
          }
        }, u), r);
      };
    c.propTypes = {
      children: s.default.node.isRequired,
      onExport: s.default.func.isRequired,
      className: s.default.string,
      style: s.default.object
    }, c.defaultProps = {
      className: "",
      style: {}
    }, t.default = c;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(14),
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = {
      ToggleList: o.default
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      a = r(0),
      u = n(a),
      l = r(1),
      i = n(l),
      s = function (e) {
        var t = e.columns,
          r = e.onColumnToggle,
          n = e.toggles,
          a = e.contextual,
          l = e.className,
          i = e.btnClassName;
        return u.default.createElement("div", {
          className: "btn-group btn-group-toggle " + l,
          "data-toggle": "buttons"
        }, t.map(function (e) {
          return o({}, e, {
            toggle: n[e.dataField]
          });
        }).map(function (e) {
          return u.default.createElement("button", {
            type: "button",
            key: e.dataField,
            className: i + " btn btn-" + a + " " + (e.toggle ? "active" : ""),
            "data-toggle": "button",
            "aria-pressed": e.toggle ? "true" : "false",
            onClick: function () {
              return r(e.dataField);
            }
          }, e.text);
        }));
      };
    s.propTypes = {
      columns: i.default.array.isRequired,
      toggles: i.default.object.isRequired,
      onColumnToggle: i.default.func.isRequired,
      btnClassName: i.default.string,
      className: i.default.string,
      contextual: i.default.string
    }, s.defaultProps = {
      btnClassName: "",
      className: "",
      contextual: "primary"
    }, t.default = s;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = r(16),
      l = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(u);
    t.default = function (e) {
      return function (e) {
        function t() {
          var e, r, a, u;
          n(this, t);
          for (var l = arguments.length, i = Array(l), s = 0; s < l; s++) i[s] = arguments[s];
          return r = a = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(i))), a.registerExposedAPI = function (e) {
            a.tableExposedAPIEmitter = e;
          }, u = r, o(a, u);
        }
        return a(t, e), t;
      }(l.default.csvOperation(e));
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(17),
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = {
      csvOperation: o.default
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      l = r(18),
      i = {
        fileName: "spreadsheet.csv",
        separator: ",",
        ignoreHeader: !1,
        ignoreFooter: !0,
        noAutoBOM: !0,
        blobType: "text/plain;charset=utf-8",
        exportAll: !0,
        onlyExportSelection: !1
      };
    t.default = function (e) {
      return function (e) {
        function t() {
          var e, r, a, s;
          n(this, t);
          for (var c = arguments.length, f = Array(c), p = 0; p < c; p++) f[p] = arguments[p];
          return r = a = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(f))), a.handleExportCSV = function (e) {
            var t = a.props,
              r = t.columns,
              n = t.exportCSV,
              o = t.keyField,
              s = (0, l.getMetaInfo)(r),
              c = !0 === n ? i : u({}, i, n),
              f = void 0;
            if (void 0 !== e) f = e;else if (c.exportAll) f = a.props.data;else if (c.onlyExportFiltered) {
              var p = {};
              a.tableExposedAPIEmitter.emit("get.filtered.rows", p), f = p.result;
            } else {
              var d = {};
              a.tableExposedAPIEmitter.emit("get.table.data", d), f = d.result;
            }
            if (c.onlyExportSelection) {
              var h = {};
              a.tableExposedAPIEmitter.emit("get.selected.rows", h);
              var b = h.result;
              f = f.filter(function (e) {
                return !!b.find(function (t) {
                  return e[o] === t;
                });
              });
            }
            var y = (0, l.transform)(f, s, r, a._, c);
            (0, l.save)(y, c);
          }, s = r, o(a, s);
        }
        return a(t, e), t;
      }(e);
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.save = t.transform = t.getMetaInfo = void 0;
    var n = r(19),
      o = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.getMetaInfo = function (e) {
      return e.map(function (e) {
        return {
          field: e.dataField,
          type: e.csvType || String,
          formatter: e.csvFormatter,
          formatExtraData: e.formatExtraData,
          header: e.csvText || e.text,
          export: !1 !== e.csvExport,
          row: Number(e.row) || 0,
          rowSpan: Number(e.rowSpan) || 1,
          colSpan: Number(e.colSpan) || 1,
          footer: e.footer,
          footerFormatter: e.footerFormatter
        };
      }).filter(function (e) {
        return e.export;
      });
    }, t.transform = function (e, t, r, n, o) {
      var a = o.separator,
        u = o.ignoreHeader,
        l = o.ignoreFooter,
        i = t.filter(function (e) {
          return e.export;
        }),
        s = "";
      return u || (s += i.map(function (e) {
        return '"' + e.header + '"';
      }).join(a), s += "\n"), 0 === e.length ? s : (s += e.map(function (e, t) {
        return i.map(function (r) {
          var o = n.get(e, r.field);
          return r.formatter && (o = r.formatter(o, e, t, r.formatExtraData)), r.type === String ? '"' + ("" + o).replace(/"/g, '""') + '"' : o;
        }).join(a);
      }).join("\n"), l || (s += "\n", s += i.map(function (t, o) {
        if ("function" == typeof t.footer) {
          var a = n.pluck(e, r[o].dataField);
          return '"' + t.footer(a, r[o], o) + '"';
        }
        return t.footerFormatter ? '"' + t.footerFormatter(r[o], o) + '"' : '"' + t.footer + '"';
      }).join(a)), s);
    }, t.save = function (e, t) {
      var r = t.noAutoBOM,
        n = t.fileName,
        a = t.blobType;
      o.default.saveAs(new Blob([e], {
        type: a
      }), n, r);
    };
  }, function (e, t, r) {
    (function (r) {
      var n, o, a;
      !function (r, u) {
        o = [], n = u, void 0 !== (a = "function" == typeof n ? n.apply(t, o) : n) && (e.exports = a);
      }(0, function () {
        "use strict";

        function t(e, t) {
          return void 0 === t ? t = {
            autoBom: !1
          } : "object" != typeof t && (console.warn("Deprecated: Expected third argument to be a object"), t = {
            autoBom: !t
          }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\ufeff", e], {
            type: e.type
          }) : e;
        }
        function n(e, t, r) {
          var n = new XMLHttpRequest();
          n.open("GET", e), n.responseType = "blob", n.onload = function () {
            l(n.response, t, r);
          }, n.onerror = function () {
            console.error("could not download file");
          }, n.send();
        }
        function o(e) {
          var t = new XMLHttpRequest();
          t.open("HEAD", e, !1);
          try {
            t.send();
          } catch (e) {}
          return 200 <= t.status && 299 >= t.status;
        }
        function a(e) {
          try {
            e.dispatchEvent(new MouseEvent("click"));
          } catch (r) {
            var t = document.createEvent("MouseEvents");
            t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
          }
        }
        var u = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof r && r.global === r ? r : void 0,
          l = u.saveAs || ("object" != typeof window || window !== u ? function () {} : "download" in HTMLAnchorElement.prototype ? function (e, t, r) {
            var l = u.URL || u.webkitURL,
              i = document.createElement("a");
            t = t || e.name || "download", i.download = t, i.rel = "noopener", "string" == typeof e ? (i.href = e, i.origin === location.origin ? a(i) : o(i.href) ? n(e, t, r) : a(i, i.target = "_blank")) : (i.href = l.createObjectURL(e), setTimeout(function () {
              l.revokeObjectURL(i.href);
            }, 4e4), setTimeout(function () {
              a(i);
            }, 0));
          } : "msSaveOrOpenBlob" in navigator ? function (e, r, u) {
            if (r = r || e.name || "download", "string" != typeof e) navigator.msSaveOrOpenBlob(t(e, u), r);else if (o(e)) n(e, r, u);else {
              var l = document.createElement("a");
              l.href = e, l.target = "_blank", setTimeout(function () {
                a(l);
              });
            }
          } : function (e, t, r, o) {
            if (o = o || open("", "_blank"), o && (o.document.title = o.document.body.innerText = "downloading..."), "string" == typeof e) return n(e, t, r);
            var a = "application/octet-stream" === e.type,
              l = /constructor/i.test(u.HTMLElement) || u.safari,
              i = /CriOS\/[\d]+/.test(navigator.userAgent);
            if ((i || a && l) && "object" == typeof FileReader) {
              var s = new FileReader();
              s.onloadend = function () {
                var e = s.result;
                e = i ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = e : location = e, o = null;
              }, s.readAsDataURL(e);
            } else {
              var c = u.URL || u.webkitURL,
                f = c.createObjectURL(e);
              o ? o.location = f : location.href = f, o = null, setTimeout(function () {
                c.revokeObjectURL(f);
              }, 4e4);
            }
          });
        u.saveAs = l.saveAs = l, void 0 !== e && (e.exports = l);
      });
    }).call(t, r(20));
  }, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function a(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function u(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      i = r(0),
      s = n(i),
      c = r(1),
      f = n(c);
    t.default = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        searchFormatted: !1,
        afterSearch: null,
        onColumnMatch: null
      };
      return function (t, r, n) {
        var i = s.default.createContext(),
          c = function (c) {
            function f(e) {
              o(this, f);
              var t = a(this, (f.__proto__ || Object.getPrototypeOf(f)).call(this, e)),
                u = e.data;
              return r() && "" !== t.props.searchText ? n(t.props.searchText) : (u = t.search(e), t.triggerListener(u, !0)), t.state = {
                data: u
              }, t;
            }
            return u(f, c), l(f, [{
              key: "getSearched",
              value: function () {
                return this.state.data;
              }
            }, {
              key: "triggerListener",
              value: function (t, r) {
                e.afterSearch && !r && e.afterSearch(t), this.props.dataChangeListener && this.props.dataChangeListener.emit("filterChanged", t.length);
              }
            }, {
              key: "UNSAFE_componentWillReceiveProps",
              value: function (e) {
                if (e.searchText !== this.props.searchText) {
                  if (r()) n(e.searchText);else {
                    var o = this.search(e);
                    this.triggerListener(o), this.setState({
                      data: o
                    });
                  }
                } else if (r()) this.setState({
                  data: e.data
                });else if (!t.isEqual(e.data, this.props.data)) {
                  var a = this.search(e);
                  this.triggerListener(a), this.setState({
                    data: a
                  });
                }
              }
            }, {
              key: "search",
              value: function (r) {
                var n = r.data,
                  o = r.columns,
                  a = r.searchText.toLowerCase();
                return n.filter(function (r, n) {
                  for (var u = 0; u < o.length; u += 1) {
                    var l = o[u];
                    if (!1 !== l.searchable) {
                      var i = t.get(r, l.dataField);
                      if (l.formatter && e.searchFormatted ? i = l.formatter(i, r, n, l.formatExtraData) : l.filterValue && (i = l.filterValue(i, r)), e.onColumnMatch) {
                        if (e.onColumnMatch({
                          searchText: a,
                          value: i,
                          column: l,
                          row: r
                        })) return !0;
                      } else if (null !== i && void 0 !== i && (i = i.toString().toLowerCase(), i.indexOf(a) > -1)) return !0;
                    }
                  }
                  return !1;
                });
              }
            }, {
              key: "render",
              value: function () {
                return s.default.createElement(i.Provider, {
                  value: {
                    data: this.state.data
                  }
                }, this.props.children);
              }
            }]), f;
          }(s.default.Component);
        return c.propTypes = {
          data: f.default.array.isRequired,
          columns: f.default.array.isRequired,
          searchText: f.default.string,
          dataChangeListener: f.default.object
        }, {
          Provider: c,
          Consumer: i.Consumer
        };
      };
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(0),
      a = n(o),
      u = r(1),
      l = n(u),
      i = r(2),
      s = n(i),
      c = function (e) {
        return a.default.createElement(s.default.Provider, e, a.default.createElement(s.default.Consumer, null, function (t) {
          return e.children(t);
        }));
      };
    c.propTypes = {
      children: l.default.func.isRequired
    }, t.default = c;
  }]);
});